var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"global-tooltip",staticStyle:{"position":"fixed"},style:({'top': _vm.top + 'px', 'left': _vm.left + 'px'})},[_c('p',{staticClass:"tooltip-text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78fb5021","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tooltip/GlobalTooltip.vue
// module id = null
// module chunks = 